import { createSlice } from '@reduxjs/toolkit';

import { locationChange } from 'modules/router/actions';

import gatesApi from './service';
import { beginAndSendGateMFA } from './thunk';
import type InitialState from './types/InitialState';

const gatesSlice = createSlice({
  name: 'gates',
  initialState: {
    mfa: undefined,
    isVerifying: false,
    selectedDealerId: undefined,
    gateConfig: undefined,
  } as InitialState,
  reducers: {
    cancelVerify: (state) => ({
      ...state,
      isVerifying: false,
      selectedDealerId: undefined,
      gateConfig: undefined,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(beginAndSendGateMFA.fulfilled, (state, action) => ({
      ...state,
      isVerifying: true,
      selectedDealerId: action.meta.arg.dealerId,
      mfa: {
        ...action.payload,
        phoneNumber: action.meta.arg.phoneNumber,
      },
    }));
    builder.addCase(locationChange, (state, action) => {
      const { pathname } = action.payload.location;
      if (pathname.endsWith('/gates/success') || pathname.endsWith('/gates')) {
        return {
          ...state,
          token: undefined,
          contextToken: undefined,
          isVerifying: false,
          selectedDealerId: undefined,
          gateConfig: undefined,
        };
      }
      return state;
    });
    builder.addMatcher(gatesApi.endpoints.loginGateMFA.matchFulfilled, (state, action) => ({
      ...state,
      token: action.payload.token,
    }));
    builder.addMatcher(gatesApi.endpoints.getGatesContext.matchFulfilled, (state, action) => ({
      ...state,
      contextToken: action.payload.token,
    }));
    builder.addMatcher(gatesApi.endpoints.sendGateMFA.matchFulfilled, (state, action) => ({
      ...state,
      mfa: {
        ...state.mfa,
        ...action.payload,
      },
    }));
    builder.addMatcher(gatesApi.endpoints.getGate.matchFulfilled, (state, action) => ({
      ...state,
      gateConfig: action.payload.config,
    }));
  },
});

export const { cancelVerify } = gatesSlice.actions;

export default gatesSlice;
